import { NOTIFICATION_TYPE, sendW2CNotification } from 'helpers/web_to_client'

export const NOTIFICATION_MESSAGE_KEY = {
    COMMON_ERROR: '#clans:clanLanding/notification/commonError',
    NO_PERMISSION: '#clans:clanLanding/notification/noPermission',
    LIMIT_REACHED: '#clans:clanLanding/notification/limitReached',
    NOT_EXIST: '#clans:clanLanding/notification/notExist',
    LENGTH_EXCEEDED: '#clans:clanLanding/notification/lengthExceeded',
    RULES_VIOLATED: '#clans:clanLanding/notification/rulesViolated',
    EDITED: '#clans:clanLanding/notification/edited',
    ARCHIVED: '#clans:clanLanding/notification/archived',
    DELETED: '#clans:clanLanding/notification/deleted',
}

const sendNotification = (type, messageKey) => {
    sendW2CNotification({
        type,
        params: {
            i18n_key: messageKey,
            i18n_data: {
                priority: 'medium',
            },
        },
    })
}

export const displayErrorNotification = sendNotification.bind(null, NOTIFICATION_TYPE.ERROR)
export const displayInfoNotification = sendNotification.bind(null, NOTIFICATION_TYPE.INFORMATION)



// WEBPACK FOOTER //
// ./state/actions/announcements/notification.js